import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export class Navbar extends Component {
    render() {
        return (
            <nav className='navbar bg-primary'>
                <Link to="/">
                <h1>
                    <i className={this.props.icon} /> {this.props.title}
                </h1>
                </Link>
                <ul>
                    <li>
                        <Link to="/">Home</Link>
                    </li>
                    <li>
                         <Link to="/Images">Images</Link>
                    </li>
                    <li>
                         <Link to="/Words">Words</Link>
                    </li>
                    <li>
                         <Link to="/About">About</Link>
                    </li>
                </ul>
            </nav>
        )
    }
}

export default Navbar



// WEBPACK FOOTER //
// ./src/components/layout/Navbar.js